import { CUSTOMER_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';

/**
 * Check if phone number already exists
 * This API checks if a customer with the given phone number already exists
 * @param {object} payload - The phone number check payload
 * @param {string} payload.phoneNumber - Phone number without dashes
 * @param {string} payload.countryCode - Country dial code (e.g., "+1")
 * @param {string} payload.phoneNumberCountry - Country ID
 * @returns {Promise} - Customer data if found, or status false
 */
export const checkPhoneNumberExistsApi = async (payload) => {
    const response = await instance.post(CUSTOMER_ROUTES.CHECK_PHONE_NUMBER, payload);
    return response.data;
};

/**
 * Create new customer
 * This API creates a new customer with all provided details
 * @param {object} payload - The customer creation payload
 * @returns {Promise} - Created customer data
 */
export const createCustomerApi = async (payload) => {
    const response = await instance.post(CUSTOMER_ROUTES.CREATE_CUSTOMER_MECHANIC, payload);
    return response?.data?.data;
};

/**
 * Update existing customer
 * This API updates an existing customer's details
 * @param {string} id - The customer ID
 * @param {object} payload - The customer update payload
 * @returns {Promise} - Updated customer data
 */
export const updateCustomerApi = async (id, payload) => {
    const response = await instance.put(CUSTOMER_ROUTES.UPDATE_CUSTOMER_DETAILS(id), payload);
    return response?.data?.data;
};

/**
 * Update existing customer for shop_imported
 * This API updates an existing customer's shop_imported details
 * @param {object} payload - The customer update payload
 * @returns {Promise} - Updated customer data
 */
export const updateCustomerImportedApi = async (payload) => {
    const response = await instance.post(CUSTOMER_ROUTES.UPDATE_IMPORTED_CUSTOMER, payload);
    return response?.data?.data;
};

/**
 *   customer detail
 * This API updates an existing customer's details
 * @param {string} id - The customer ID
 * @param {object} payload - The customer update payload
 * @returns {Promise} - Updated customer data
 */
export const shopCreatedCustomerDetailApi = async (id) => {
    const response = await instance.get(CUSTOMER_ROUTES.GET_SHOP_CREATED_CUSTOMER_DETAIL(id));
    return response?.data?.data;
};

export const shopImportedCustomerDetailApi = async (id) => {
    const response = await instance.get(CUSTOMER_ROUTES.GET_SHOP_IMPORTED_CUSTOMER_DETAIL(id));
    return response?.data?.data;
};

export const deleteCustomerApi = async (id) => {
    const response = await instance.delete(CUSTOMER_ROUTES.DELETE_CUSTOMER(id));
    return response?.data?.data;
};
